<template>
  <div class="cust-border-0">
    <b-modal id="edit-modal" okTitle="Save" centered hide-header>
      <div class="mb-6">
        <p class="font-semibold text-md pb-1">Author Name</p>
        <base-input
          placeholder="Enter Author Name"
          class="cust-mb0"
        ></base-input>
      </div>
      <div class="mb-6">
        <p class="font-semibold text-md pb-1">Course Name</p>
        <base-input
          placeholder="Enter Course Name"
          class="cust-mb0"
        ></base-input>
      </div>
      <div class="mb-6">
        <p class="font-semibold text-md pb-1">Phone No.</p>
        <base-input placeholder="Enter Phone no." class="cust-mb0"></base-input>
      </div>
      <div class="mb-6">
        <p class="font-semibold text-md pb-1">Email ID</p>
        <base-input placeholder="Enter EmailID" class="cust-mb0"></base-input>
      </div>
      <div class="mb-6">
        <p class="font-semibold text-md pb-1">Signature</p>
        <div class="flex">
          <div class="flex px-5 py-1 bg-f4f5f6 rounded-full">
            <p class="text-xs font-semibold">UploadedSignatureName.pdf</p>
            <feather-icon
              icon="XIcon"
              class="font-semibold cursor-pointer icon18px ml-5 my-auto"
            ></feather-icon>
          </div>
        </div>
      </div>
      <div class="">
        <p class="font-semibold text-md pb-1">Curriculum</p>
        <base-input
          placeholder="Enter Curriculum"
          class="cust-mb0"
        ></base-input>
      </div>
      <!--<div class="mb-6">
        <p class="font-semibold text-md pb-1">Chapter Name</p>
        <base-input
          placeholder="Enter Chapter Name"
          class="cust-mb0"
        ></base-input>
      </div> -->
    </b-modal>
    <b-card v-show="shownewpage" class="cust-border-0 border-none">
      <div>
        <div class="mb-4">
          <base-button
            icon
            type=""
            class="custpad5-10 bg-f4f5f6"
            v-if="shownewpage"
            @click="shownewpage = false"
          >
            <span class="btn-inner--icon"><i class="ni ni-bold-left"></i></span>

            <span class="btn-inner--text">Back</span>
          </base-button>
        </div>
        <AddtrainerDashboard />
      </div>
    </b-card>
    <b-card v-if="!shownewpage">
      <modal :show.sync="editModal" header-classes="bg-primary p-3">
        <h6 slot="header" class="modal-title text-white font-semibold pt-1">
          EDIT IMAGE ORDER
        </h6>
        <AddPageDetail :data="selectedAuthor" :editModal="editModal" />
        <template slot="footer">
          <base-button @click="saveChanges(name)" type="primary"
            >SAVE CHANGES</base-button
          >
          <base-button
            type="secondary"
            class="ml-auto"
            @click="editModal = false"
            >CLOSE</base-button
          >
        </template>
      </modal>

      <div class="flex justify-between items-center">
        <div>
          <h2 class="text-2xl font-semibold">Author</h2>

          <!-- <small class=" text-muted "
            >Lorem ipsum dolor sit amet, consectetur adipiscing elit,
          </small> -->
        </div>
        <div class="flex">
          <base-button outline class="px-6 py-1 mx-1" type="primary">
            <download-excel
              class="mr-1 flex"
              default-value=""
              :fetch="fetchData"
              :fields="json_fields"
              worksheet="My Worksheet"
              name="Excelfile.xls"
            >
              <span class="btn-inner--text flex"
                ><feather-icon
                  icon="UploadIcon"
                  class="mr-2 cust-HW"
                ></feather-icon
                >Export</span
              >
            </download-excel>
          </base-button>
          <!-- <base-button
            outline
            type="success"
            class="flex custpad5-10 mx-1"
            @click="shownewpage = true"
          >
            <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>Add Author
          </base-button> -->
        </div>
      </div>
      <b-input-group class="mt-12">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          min="0.00"
          @input="searchData"
          v-model="search"
          placeholder="Enter Search...."
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class="cursor-pointer mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <el-table
        class="table-responsive table-flush mt-6"
        header-row-class-name="thead-light table-th-color"
        :data="authors"
        border
      >
        <el-table-column
          prop="id"
          type="index"
          label="Sr No."
          :index="getIndex"
          min-width="130px"
          sortable
        >
          <!-- <template v-slot="{ row }">
            <span class="text-black">{{ row._id }}</span>
          </template> -->
        </el-table-column>

        <el-table-column
          label="Author Name"
          min-width="150px"
          prop="title"
          sortable
        >
          <template v-slot="{ row }">
            <span class="text-black">{{
              `${row.userId[0].firstname} ${row.userId[0].lastname}`
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="Phone no."
          min-width="130px"
          prop="orderno"
          sortable
        >
          <template v-slot="{ row }">
            <span class="text-black">{{ row.userId[0].mobile }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Action" min-width="130px">
          <!-- <base-button
              type="primary"
              size="sm"
              @click="updateStatus(row)"
              :class="{
                'btn-success': row.BA_status == 'Approved',

                'btn-warning': row.BA_status != 'Approved'
              }"
              :disabled="row.isStriked || tasklist.milestone !== 'Analysis'"
            >
              {{ row.BA_status == "Approved" ? "Approved" : "Approve" }}
            </base-button> -->
          <template v-slot="{ row }">
            <base-button
              class="px-4 py-1 mx-1"
              type="primary"
              v-if="!row.adminapproval"
              @click="approves(row)"
            >
              Approve
            </base-button>
            <base-button
              class="px-4 py-1 mx-1"
              type="danger"
              v-show="row.adminapproval"
              @click="reject(row)"
            >
              Reject
            </base-button>
          </template>
        </el-table-column>
      </el-table>

      <b-card-footer class="py-4 d-flex justify-content-end">
        <base-pagination
          v-model="currentPage"
          :per-page="perPage"
          :total="total_row"
          @change="handlePageChange"
        ></base-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>
<script>
import "../../scss/Index.scss";
import Data from "./components/Data";
import AddPageDetail from "./components/AddPageDetail";
// import AddPageDataSidebar from "./components/AddPageDataSidebar.vue";
import AddtrainerDashboard from "./components/AddtrainerDashboard";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
import { mapState } from "vuex";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    AddPageDetail,
    selectedauthor: "",
    AddtrainerDashboard,
  },
  data() {
    return {
      currentPage: 1,
      editModal: false,
      openAddBannerSidebar: false,
      shownewpage: false,
      // adminApproval: true,
      // adminReject: false,
      approve: false,
      startIndex: 1,
      perPage: 5,
      total_row: 1,
      search: "",
    };
  },
  methods: {
    addBanner() {
      this.toggleAddBannerSidebar(true);
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    },
    deletePopup() {
      this.$swal({
        title: "Are you sure?",

        text: "You won't be able to revert this!",

        icon: "warning",

        showCancelButton: true,

        confirmButtonColor: "#830c81",

        cancelButtonColor: "#d33",

        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.$swal("Deleted!", "Your file has been deleted.", "success");
        }
      });
    },
    async approves(author) {
      const { data } = await this.$store.dispatch("author/editAuthors", {
        _id: author._id,
        adminapproval: "true",
      });
      this.getAuthorDetails();
      // console.log(author);
      // console.log(data);
    },
    async reject(author) {
      const { data } = await this.$store.dispatch("author/editAuthors", {
        _id: author._id,
        adminapproval: "false",
      });
      this.getAuthorDetails();

      // console.log(author);
      // console.log(data);
    },
    async getAuthorDetails() {
      let payload = {
        limit: 5,
        offset: (this.currentPage - 1) * 5,
        search: this.search,
      };
      const data = await this.$store.dispatch("author/getAuthors", payload);
      // console.log(this.authors);
      this.total_row = data.data[0].totalCount;
    },

    searchData() {
      this.getAuthorDetails();
    },
    handlePageChange(value) {
      this.currentPage = value;
      try {
        this.getAuthorDetails();
      } catch (error) {}
    },
    async fetchData() {
      let loader = this.$loading();
      try {
        const data = await this.$store.dispatch("author/getAuthors");
        // console.log(data);
        if (data.code == 200) {
          loader.close();
          let data2 = [];
          data.data[0].result.forEach((ele) => {
            data2.push(ele.userId[0]);
          });
          return data2;
        }
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
  },
  mounted() {
    this.getAuthorDetails();
  },
  computed: {
    ...mapState("author", ["authors"]),
    ...mapState("eLearning", ["selectedData"]),
    getIndex() {
      return (index) => {
        return index + this.startIndex + this.currentPage * 5 - 5;
      };
    },
    json_fields() {
      return {
        first_name: "firstname",
        last_name: "lastname",
        mobile_no: "mobile",
        email_id: "email",
        // user_type: "role",
        created_at: {
          field: "createdAt",
          callback: (date) => {
            return new Date(date).toDateString();
          },
        },
        // view_details: "details",
      };
    },
  },
};
</script>
